import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { css } from "styled-components";

productCardStyles.rightColumnGridItem = {
    width: [8, 8, 8, 9, 9],
    css: css`
        div div {
            width: 100% !important;
        }
    `,
};
